// Utilities for Amazon Publisher Services (APS)
const SLOT_ID = 'Hudl_Video';
const MEDIA_TYPE = 'video';
// A slow or blocked apstag falls back to the preroll without an Amazon bid rather than
// holding the player.
const APS_READY_TIMEOUT_MS = 1500;

export const fetchAPSVideoBid = async () =>
{
    // _AmazonApsScript resolves this after apstag.init. apstag loads only after consent
    // resolves, so without the wait the bid check often runs before apstag exists.
    if (window.__apsReady)
    {
        let timer;
        await Promise.race([
            window.__apsReady,
            new Promise(resolve => { timer = setTimeout(resolve, APS_READY_TIMEOUT_MS); }),
        ]);
        clearTimeout(timer);
    }

    return new Promise((resolve) =>
    {
        if (!window.apstag?.fetchBids)
        {
            resolve({});
            return;
        }

        try
        {
            window.apstag.fetchBids(
                {
                    slots: [
                        {
                            slotID: SLOT_ID,
                            mediaType: MEDIA_TYPE,
                        },
                    ],
                    timeout: 2000,
                },
                function (bids)
                {
                    if (bids.length === 0)
                    {
                        resolve({});
                    } else
                    {
                        resolve(bids[0]);
                    }
                }
            );
        } catch (e)
        {
            console.error('Error fetching APS video bid', e);
            resolve({});
        }
    });
};

// Create a object with the targeting key value pairs
// that can be inserted into `pageData.ads.preRollAdData`
export const parseBidInfo = (bid) =>
{
    if (!bid || !bid.qsParams) return {};

    const params = {};
    try
    {
        bid.qsParams.split('&').forEach(token =>
        {
            if (token)
            {
                const [key, value] = token.split('=');
                params[key] = value;
            }
        });
    }
    catch (e)
    {
        console.warn('Unable to parse targeting data', e);
        return {};
    }

    return params;
}
